import { Button } from "@material-ui/core";
import React, { useEffect } from "react";
import {
  Box,
  ButtonBase,
  FormControl,
  InputLabel,
  Link,
  MenuItem,
  Modal,
  TextField,
} from "@mui/material";
import { validatePincode } from "../../../Supporting files/HelpingFunction";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import RKTextField from "../../../Supporting files/RKTextField/RKTextField";
import SelectDropdown from "../../../Supporting files/SelectDropdown/SelectDropdown";
//import { FALSE } from "sass";
import SlidingPanel from "react-sliding-side-panel";
interface Props {
  attrName: string;
  open_status: boolean;
  value_update: Function;
}

const HealthForm: React.FC<Props> = ({
  open_status,
  value_update,
  attrName,
}) => {
  //Health Form Variables
  const [ageData, setAgeData] = React.useState([
    { value: "18", label: "18 Years" },
  ]);
  const [pageStatus, setPageStatus] = React.useState<number>(1);
  const [noOfAdult, setNoOfAdult] = React.useState(1);
  const [noOfChild, setNoOfChild] = React.useState(0);
  const [age, setAge] = React.useState("");
  const [gender, setGender] = React.useState("");
  const [pincode, setPincode] = React.useState("");
  const [warnAge, setWarnAge] = React.useState(false);
  const [warnGender, setWarnGender] = React.useState(false);
  const [warnPincode, setWarnPincode] = React.useState(false);

  const validateHealthForm = () => {
    let warn_age = age.toString().length == 0 ? true : false;
    let warn_gender = gender.toString().length == 0 ? true : false;
    let warn_pincode = !validatePincode(pincode);

    setWarnAge(warn_age);
    setWarnGender(warn_gender);
    setWarnPincode(warn_pincode);

    if (warn_age == false && warn_gender == false && warn_pincode == false) {
    }
  };

  useEffect(() => {
    var age_data = [];
    for (var i = 18; i <= 100; i++) {
      age_data.push({ value: i.toString(), label: i.toString() + " Years" });
    }
    setAgeData(age_data);
  }, []);

  const updateMasterState = (
    attrName: any,
    value: string | boolean | number
  ) => {
    attrName(value);
  };

  const age_data = [
    { key: "18 years", value: "18 years" },
    { key: "20 years", value: "20 years" },
    { key: "21 years", value: "21 years" },
    { key: "22 years", value: "22 years" },
    { key: "23 years", value: "23 years" },
    { key: "24 years", value: "24 years" },
  ];
  const gender_data = [
    { key: "male", value: "Male" },
    { key: "female", value: "Female" },
  ];
  const changePageStatus = (status: boolean) => {
    if (status === true) {
      if (pageStatus < 2) {
        setPageStatus(pageStatus + 1);
      }
    } else {
      if (pageStatus > 1) {
        setPageStatus(pageStatus - 1);
      }
    }
  };
  return (
    <>
      <SlidingPanel
        type={"right"}
        isOpen={open_status}
        size={75}
        backdropClicked={() => value_update(attrName, false)}>
        <div>
          {pageStatus == 2 ? null : (
            <Grid container spacing={3} alignItems="center">
              <Grid xs={6}>
                <h4 className="mb-0 mt-2">Health Insurance </h4>
              </Grid>
            </Grid>
          )}
          {pageStatus == 2 ? null : (
            <div className="scrollable_area">
              <Grid container spacing={3}>
                <Grid xs={12} sx={{ padding: "0px" }}>
                  <div>
                    <Grid container spacing={2}>
                      <Grid xs={5} sx={{ textAlign: "center" }}>
                        <p className="popup-subheading">Whom to Insure ?</p>
                        <div className="main-border-ncb">
                          <Button
                            className={noOfAdult == 1 ? "ncbSelect" : "ncb"}
                            onClick={() => {
                              setNoOfAdult(1);
                            }}>
                            1 Adult
                          </Button>
                          <Button
                            className={noOfAdult == 2 ? "ncbSelect" : "ncb"}
                            onClick={() => {
                              setNoOfAdult(2);
                            }}>
                            2 Adults
                          </Button>
                        </div>
                      </Grid>
                      <Grid xs={7}>
                        <p className="popup-subheading">Children</p>
                        <div className="main-border-ncb">
                          <Button
                            className={noOfChild == 0 ? "ncbSelect" : "ncb"}
                            onClick={() => {
                              setNoOfChild(0);
                            }}>
                            0
                          </Button>
                          <Button
                            className={noOfChild == 1 ? "ncbSelect" : "ncb"}
                            onClick={() => {
                              setNoOfChild(1);
                            }}>
                            1
                          </Button>
                          <Button
                            className={noOfChild == 2 ? "ncbSelect" : "ncb"}
                            onClick={() => {
                              setNoOfChild(2);
                            }}>
                            2
                          </Button>
                          <Button
                            className={noOfChild == 3 ? "ncbSelect" : "ncb"}
                            onClick={() => {
                              setNoOfChild(3);
                            }}>
                            3
                          </Button>
                          <Button
                            className={noOfChild == 4 ? "ncbSelect" : "ncb"}
                            onClick={() => {
                              setNoOfChild(4);
                            }}>
                            4
                          </Button>
                        </div>
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      spacing={2}
                      justifyContent="center"
                      className="mb-4">
                      <Grid xs={12} textAlign="center">
                        {noOfAdult == 1 ? (
                          <h5 className="subHeading mt-2 mb-0">Your Details</h5>
                        ) : null}
                        {noOfAdult == 2 ? (
                          <h5 className="subHeading mt-2 mb-0">
                            Eldest Member's Details
                          </h5>
                        ) : null}
                      </Grid>
                      <Grid xs={4} className="inputField">
                        <SelectDropdown
                          class_name="inputField"
                          title="Age"
                          value={age}
                          attrName={setAge}
                          value_update={updateMasterState}
                          dropdown_data={age_data}
                          warn_status={false}
                        />
                      </Grid>
                      <Grid xs={4} className="inputField">
                        <SelectDropdown
                          class_name="inputField"
                          title="Gender"
                          value={gender}
                          attrName={setGender}
                          value_update={updateMasterState}
                          dropdown_data={gender_data}
                          warn_status={false}
                        />
                      </Grid>
                      <Grid xs={4}>
                        <RKTextField
                          class_name="inputField"
                          title="Pincode"
                          value={pincode}
                          value_update={updateMasterState}
                          attrName={setPincode}
                          warn_status={warnPincode}
                        />
                      </Grid>
                    </Grid>
                  </div>
                </Grid>
              </Grid>
            </div>
          )}
          {pageStatus == 2 ? (
            <Grid container spacing={2}>
              <Grid xs={12} className="tick_animation">
                <svg
                  className="checkmark"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 52 52">
                  <circle
                    className="checkmark__circle"
                    cx="26"
                    cy="26"
                    r="25"
                    fill="none"
                  />
                  <path
                    className="checkmark__check"
                    fill="none"
                    d="M14.1 27.2l7.1 7.2 16.7-16.8"
                  />
                </svg>
                <p className="quote_success">
                  New Health Insurance Policy has been added successfully!
                </p>
              </Grid>
            </Grid>
          ) : null}
          <Grid container spacing={2}>
            {pageStatus == 2 ? null : (
              <Grid
                xs={12}
                style={{ textAlign: "center", position: "relative" }}
                className="ctaBtn">
                <Button
                  variant="contained"
                  className="submitBtn fixedbtn"
                  onClick={() => {
                    changePageStatus(true);
                  }}>
                  {pageStatus == 1 ? "Submit" : "Continue"}
                </Button>
              </Grid>
            )}
          </Grid>
        </div>
      </SlidingPanel>
    </>
  );
};

export default HealthForm;
